import { useEffect, useState } from "react";
import SideMenu from "../General/SideMenu";
import ReactTable from "../General/ReactTable";
import { useDispatch } from "react-redux";
import { Show_MsgBox, setload_Screen } from "../ReduxStore/Message";
import { userApp } from "../Admin/Utility";
import Messagedialogbox from "../General/Messagedialogbox";

// ═══════════════════════════════════════════════════════════════
//  OTP POPUP — same branded pattern as CredentialModal above.
//  Reused for both the Push-OTP and File-OTP steps (title/subtitle/
//  submitLabel differ, everything else is identical).
// ═══════════════════════════════════════════════════════════════
function OTPModal({ title, subtitle, otp, onChange, onSubmit, onClose, onResend, resendCooldown, submitLabel, submitting }) {
  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 10000,
        background: "rgba(0,0,0,0.6)",
        backdropFilter: "blur(4px)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          background: "#fff",
          borderRadius: 14,
          width: 400,
          boxShadow: "0 24px 80px rgba(0,0,0,0.3)",
          animation: "modalPop 0.25s cubic-bezier(0.34,1.56,0.64,1)",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            background: "darkgreen",
            padding: "24px 28px",
            display: "flex",
            alignItems: "center",
            gap: 14,
          }}
        >
          <div
            style={{
              width: 44,
              height: 44,
              borderRadius: 10,
              background: "rgba(255,255,255,0.12)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: 22,
            }}
          >
            📱
          </div>
          <div>
            <div style={{ fontWeight: 700, fontSize: 16, color: "#fff" }}>{title}</div>
            <div style={{ fontSize: 12, color: "rgba(255,255,255,0.6)", marginTop: 2 }}>{subtitle}</div>
          </div>
          <button
            onClick={onClose}
            style={{
              marginLeft: "auto",
              width: 28,
              height: 28,
              borderRadius: "50%",
              background: "rgba(255,255,255,0.15)",
              border: "none",
              color: "#fff",
              fontSize: 14,
              cursor: "pointer",
              flexShrink: 0,
            }}
          >
            ✕
          </button>
        </div>
        <div style={{ padding: "24px 28px 20px" }}>
          <div style={{ marginBottom: 8 }}>
            <label
              style={{
                fontSize: 11,
                fontWeight: 700,
                color: "#6b7280",
                display: "block",
                marginBottom: 6,
                letterSpacing: "0.5px",
                textTransform: "uppercase",
              }}
            >
              6-Digit OTP
            </label>
            <input
              type="text"
              inputMode="numeric"
              pattern="[0-9]*"
              maxLength={6}
              className="form-control"
              placeholder="000000"
              value={otp}
              onChange={(e) => onChange(e.target.value.replace(/\D/g, ""))}
              autoComplete="off"
              style={{ fontSize: 20, letterSpacing: "6px", textAlign: "center", fontWeight: 700 }}
            />
          </div>
          <div style={{ marginBottom: 20, textAlign: "right" }}>
            <button
              type="button"
              onClick={onResend}
              disabled={resendCooldown > 0}
              style={{
                background: "none",
                border: "none",
                color: resendCooldown > 0 ? "#9ca3af" : "darkgreen",
                fontSize: 12,
                fontWeight: 600,
                cursor: resendCooldown > 0 ? "not-allowed" : "pointer",
                padding: 0,
              }}
            >
              {resendCooldown > 0 ? `Resend OTP in ${resendCooldown}s` : "Resend OTP"}
            </button>
          </div>
          <div style={{ display: "flex", gap: 10 }}>
            <button
              onClick={onClose}
              disabled={submitting}
              style={{
                flex: 1,
                padding: "10px",
                borderRadius: 8,
                border: "1.5px solid #e5e7eb",
                background: "#fff",
                color: "#374151",
                fontWeight: 600,
                fontSize: 13,
                cursor: submitting ? "not-allowed" : "pointer",
                opacity: submitting ? 0.5 : 1,
              }}
            >
              Cancel
            </button>
            <button
              onClick={onSubmit}
              disabled={submitting || otp.length !== 6}
              style={{
                flex: 1,
                padding: "10px",
                borderRadius: 8,
                border: "none",
                background: submitting || otp.length !== 6 ? "#9ca3af" : "darkgreen",
                color: "#fff",
                fontWeight: 700,
                fontSize: 13,
                cursor: submitting || otp.length !== 6 ? "not-allowed" : "pointer",
              }}
            >
              {submitting ? "Verifying..." : submitLabel}
            </button>
          </div>
        </div>
      </div>
      <style>{`@keyframes modalPop{from{opacity:0;transform:scale(0.85)}to{opacity:1;transform:scale(1)}}`}</style>
    </div>
  );
}
// ═══════════════════════════════════════════════════════════════
//  CREDENTIAL POPUP — ported 1:1 from EInvoice.js's CredentialModal
//  (same dark-green branded header, icon, info banner, button style)
//  so this matches the app's actual professional modal pattern
//  instead of the plain gstr1-modal-overlay/popup-header markup.
// ═══════════════════════════════════════════════════════════════
function CredentialModal({ cred, onChange, onSave, onClose, saving }) {
  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 10000,
        background: "rgba(0,0,0,0.6)",
        backdropFilter: "blur(4px)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          background: "#fff",
          borderRadius: 14,
          width: 420,
          boxShadow: "0 24px 80px rgba(0,0,0,0.3)",
          animation: "modalPop 0.25s cubic-bezier(0.34,1.56,0.64,1)",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            background: "darkgreen",
            padding: "24px 28px",
            display: "flex",
            alignItems: "center",
            gap: 14,
          }}
        >
          <div
            style={{
              width: 44,
              height: 44,
              borderRadius: 10,
              background: "rgba(255,255,255,0.12)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: 22,
            }}
          >
            🔐
          </div>
          <div>
            <div style={{ fontWeight: 700, fontSize: 16, color: "#fff" }}>
              GSTR-1 API Credentials
            </div>
            <div
              style={{
                fontSize: 12,
                color: "rgba(255,255,255,0.6)",
                marginTop: 2,
              }}
            >
              GST Portal Login — required for GSTR-1 API access
            </div>
          </div>
        </div>
        <div style={{ padding: "24px 28px 20px" }}>
          <div style={{ marginBottom: 16 }}>
            <label
              style={{
                fontSize: 11,
                fontWeight: 700,
                color: "#6b7280",
                display: "block",
                marginBottom: 6,
                letterSpacing: "0.5px",
                textTransform: "uppercase",
              }}
            >
              GST Username
            </label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter GST portal username"
              value={cred.ApiUserName}
              onChange={(e) => onChange({ ...cred, ApiUserName: e.target.value })}
              autoComplete="off"
              style={{ fontSize: 13 }}
            />
          </div>
          <div style={{ marginBottom: 24 }}>
            <label
              style={{
                fontSize: 11,
                fontWeight: 700,
                color: "#6b7280",
                display: "block",
                marginBottom: 6,
                letterSpacing: "0.5px",
                textTransform: "uppercase",
              }}
            >
              GST Password
            </label>
            <input
              type="password"
              className="form-control"
              placeholder="Enter GST portal password"
              value={cred.ApiPassword}
              onChange={(e) => onChange({ ...cred, ApiPassword: e.target.value })}
              autoComplete="new-password"
              style={{ fontSize: 13 }}
            />
          </div>
          <div
            style={{
              background: "#eff6ff",
              border: "1px solid #bfdbfe",
              borderRadius: 8,
              padding: "10px 12px",
              marginBottom: 20,
              fontSize: 11.5,
              color: "#1e40af",
              lineHeight: 1.5,
            }}
          >
            ℹ️ These credentials are used only for GSTR-1 filing API authentication (GST portal -&gt; API Registration -&gt; Through GSP). They are stored securely and encrypted.
          </div>
          <div style={{ display: "flex", gap: 10 }}>
            <button
              onClick={onClose}
              disabled={saving}
              style={{
                flex: 1,
                padding: "10px",
                borderRadius: 8,
                border: "1.5px solid #e5e7eb",
                background: "#fff",
                color: "#374151",
                fontWeight: 600,
                fontSize: 13,
                cursor: saving ? "not-allowed" : "pointer",
                opacity: saving ? 0.5 : 1,
              }}
            >
              Cancel
            </button>
            <button
              onClick={onSave}
              disabled={saving}
              style={{
                flex: 1,
                padding: "10px",
                borderRadius: 8,
                border: "none",
                background: saving ? "#9ca3af" : "darkgreen",
                color: "#fff",
                fontWeight: 700,
                fontSize: 13,
                cursor: saving ? "not-allowed" : "pointer",
              }}
            >
              {saving ? "Saving..." : "Save & Push"}
            </button>
          </div>
        </div>
      </div>
      <style>{`@keyframes modalPop{from{opacity:0;transform:scale(0.85)}to{opacity:1;transform:scale(1)}}`}</style>
    </div>
  );
}


const RPT = {
  B2B: 107,
  B2CL: 108,
  B2CS: 109,
  CDNR: 110,
  CDNUR: 111,
  HSN: 113,
};


const CATEGORY_FIELD_MAP = {
  B2B: {
    confirmed: true,
    taxable: "Taxable Value",
    taxFields: ["Integrated Tax Paid-IGST", "Central Tax Paid-CGST", "State/UT Tax Paid-SGST"],
    hsn: "HSNCode",
    invoiceNo: "Invoice Number",
  },
  B2CL: {
    confirmed: true,
    taxable: "Taxable Value",
    taxFields: ["Tax Rate"], // misleadingly named column, actually holds the tax amount
    hsn: null, // no per-row HSN in this report, HSN is reported separately
    invoiceNo: "Invoice Number",
  },
  B2CS: {
    // Same reporting engine/structure as confirmed B2CL above.
    confirmed: true,
    taxable: "Taxable Value",
    taxFields: ["Tax Rate"],
    hsn: null,
    invoiceNo: "Invoice Number",
  },
  CDNR: {
    confirmed: true,
    taxable: "Taxable Value",
    noteValue: "Note Value",
    cess: "Cess Amount",
    taxFields: [], // no direct IGST/CGST/SGST columns -- tax is derived, see Summarize_Rows
    hsn: null, // credit/debit notes don't carry HSN in this report
    invoiceNo: "Note Number",
  },
  CDNUR: {
    confirmed: true,
    taxable: "Taxable Value",
    noteValue: "Note Value",
    cess: "Cess Amount",
    taxFields: [],
    hsn: null,
    invoiceNo: "Note Number",
  },
  HSN: {
    confirmed: true,
    taxable: "TaxableAmt",
    taxFields: ["IGSTTaxAmt", "CGSTTaxAmt", "SGSTTaxAmt"],
    hsn: "HSN",
    invoiceNo: null,
  },
};

const MONTHS = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December",
];

function Gstr1() {
  const dispatch = useDispatch();

  const today = new Date();
  const [iMonth, setiMonth] = useState(today.getMonth() + 1);
  const [iYear, setiYear] = useState(today.getFullYear());

  const [strActiveTab, setstrActiveTab] = useState("Overview"); // Overview | Push | File
  const [strActiveCard, setstrActiveCard] = useState("B2B");

  const [objRaw, setobjRaw] = useState({
    B2B: [], B2CL: [], B2CS: [], CDNR: [], CDNUR: [], HSN: [],
  });
  // EntDesign per category -- drives dynamic table columns, same as GeneralReports.js
  const [objDesign, setobjDesign] = useState({
    B2B: [], B2CL: [], B2CS: [], CDNR: [], CDNUR: [], HSN: [],
  });

  const [objSummary, setobjSummary] = useState({
    B2B: { count: 0, taxable: 0, tax: 0 },
    B2CL: { count: 0, taxable: 0, tax: 0 },
    B2CS: { count: 0, taxable: 0, tax: 0 },
    CDNR: { count: 0, taxable: 0, tax: 0 },
    CDNUR: { count: 0, taxable: 0, tax: 0 },
    HSN: { count: 0, taxable: 0, tax: 0 },
  });

  const [arrValidationErrors, setarrValidationErrors] = useState([]);
  const [strFilingStatus, setstrFilingStatus] = useState("Unfiled"); // Unfiled | Pushed | Filed

  // ---- Document Issued (mandatory manual entry, same as Zoho) ----
  const [strDocFrom, setstrDocFrom] = useState("");
  const [strDocTo, setstrDocTo] = useState("");
  const [iDocTotal, setiDocTotal] = useState(0);
  const [iDocCancelled, setiDocCancelled] = useState(0);

  // ---- OTP / Auth flow ----
  const [isOTPModal, setisOTPModal] = useState(false);
  const [strOTP, setstrOTP] = useState("");
  const [strAuthToken, setstrAuthToken] = useState("");
  const [strAckNo, setstrAckNo] = useState("");

  // ---- File OTP (separate EVC OTP, needed only at final File step) ----
  const [isFileOTPModal, setisFileOTPModal] = useState(false);
  const [strFileOTP, setstrFileOTP] = useState("");

  // ---- GSTR API credential (GST portal -> API Registration -> Through GSP) ----
  // Mandatory before Push_to_GSTN can work. Without this popup, a first-time
  // customer has literally no way to set this up from this screen -- Request_OTP
  // just fails on the backend with "credential not set up" and dead-ends here.
  const [isCredModal, setisCredModal] = useState(false);
  const [gstrCred, setgstrCred] = useState({ ApiUserName: "", ApiPassword: "" });
  const [isCredSaving, setisCredSaving] = useState(false);
  const [isCredSaved, setisCredSaved] = useState(null); // null = unknown yet, true/false once checked

  // ---- Resend-OTP cooldowns (both OTP types) -- prevents spamming GSTN
  // with repeat OTP requests, and gives the customer a clear "try again
  // in Ns" signal instead of a dead modal if the first OTP never arrives ----
  const [iResendCooldown, setiResendCooldown] = useState(0);
  const [iFileResendCooldown, setiFileResendCooldown] = useState(0);

  useEffect(() => {
    if (iResendCooldown <= 0) return;
    const t = setTimeout(() => setiResendCooldown((s) => s - 1), 1000);
    return () => clearTimeout(t);
  }, [iResendCooldown]);

  useEffect(() => { 
    if (iFileResendCooldown <= 0) return;
    const t = setTimeout(() => setiFileResendCooldown((s) => s - 1), 1000);
    return () => clearTimeout(t);
  }, [iFileResendCooldown]);

  // iClientId -- assumption: localStorage.ClientId, same pattern as localStorage.db / localStorage.UserId
  const iClientId = Number(localStorage.ClientId);

  useEffect(() => {
    console.log("==== GSTR1 DEBUG: Load_GSTR1Data triggered (iMonth/iYear changed or mount) — this resets strAuthToken to empty ====", { iMonth, iYear });
    Load_GSTR1Data();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [iMonth, iYear]);

  const AlertMessage = (Msg, type) => {
    dispatch(Show_MsgBox({ Message: Msg, Type: type, isMsg: true }));
  };

  const JsontoArray = (DataArray) => (DataArray !== null ? JSON.parse(DataArray) : []);

  // Pulls all 6 GSTR1 section reports and builds the summary cards.
  // Reuses the existing generic Reports/Load_GeneralReports endpoint --
  // no new backend report logic needed for this part, views already exist.
  const Load_GSTR1Data = async () => {
    try {
      await dispatch(setload_Screen(true));
      const strFromDate = `${iYear}-${String(iMonth).padStart(2, "0")}-01`;
      const objBase = {
        iPartyId: 0,
        strColName: "",
        strPartyName: "",
        strSearch: "",
        strCompanyDB: localStorage.db,
        strMasterDB: localStorage.Msdb,
        iUserId: Number(localStorage.UserId),
        CurrtPage: 1,
        strFromDate: strFromDate,
        iMonth: iMonth,
        iYear: iYear,
      };

      const keys = Object.keys(RPT);
      const calls = keys.map((key) =>
        userApp.post(`Reports/Load_GeneralReports/`, { ...objBase, iRptId: RPT[key] })
      );

      const results = await Promise.all(calls);
      const newRaw = {};
      const newDesign = {};
      const newSummary = {};

      results.forEach((Res, idx) => {
        const key = keys[idx];
        if (Res.data.strStatus === "Success") {
          const rows = JsontoArray(Res.data.EntReport);
          newRaw[key] = rows;
          newDesign[key] = (Res.data.EntDesign || []).sort((a, b) => a.inOrderTo - b.inOrderTo);
          newSummary[key] = Summarize_Rows(key, rows);
        } else {
          newRaw[key] = [];
          newDesign[key] = [];
          newSummary[key] = { count: 0, taxable: 0, tax: 0 };
        }
      });

      setobjRaw(newRaw);
      setobjDesign(newDesign);
      setobjSummary(newSummary);
      Validate_GSTR1(newRaw);
      await Load_FilingStatus();
    } catch (e) {
      AlertMessage(e.message, "error");
    } finally {
      dispatch(setload_Screen(false));
    }
  };

  // Fetches the real Unfiled/Pushed/Filed status + ack number for this
  // month/year from GST_GSTR1_FilingStatus, and Document Issued series
  // from GST_GSTR1_DocSeries. Without this, the status pill and Push/File
  // buttons would show stale in-memory state from whatever period the
  // user was last looking at, instead of the truth for THIS period --
  // and a page refresh would wrongly reset an already-Filed period back
  // to "Unfiled" on screen (even though nothing changed in GSTN/DB).
  // TODO (backend): needs a new GST/Get_FilingStatus endpoint wired to
  // the existing IrbsGSTR1Filing.GetFilingStatus() + GetDocSeries() DAL
  // methods -- these were built but never exposed via the Controller.
  const Load_FilingStatus = async () => {
    try {
      const objReq = { iMonth, iYear, strCompanyDB: localStorage.db };
      const Res = await userApp.post(`GST/Get_FilingStatus`, objReq);
      if (Res.data.strStatus === "Success") {
        setstrFilingStatus(Res.data.strFilingStatus || "Unfiled");
        setstrAckNo(Res.data.strAckNo || "");
        setstrDocFrom(Res.data.strDocFrom || "");
        setstrDocTo(Res.data.strDocTo || "");
        setiDocTotal(Res.data.iDocTotal || 0);
        setiDocCancelled(Res.data.iDocCancelled || 0);
        // Auth token is intentionally NOT restored here -- GSTN session
        // tokens are short-lived, so resuming an in-progress Push->File
        // after a page refresh isn't supported by design. If status is
        // "Pushed" but the user reloaded the page, they'll need to Push
        // again (re-verify OTP) before File Return is available -- this
        // mirrors how GSTN's own OTP session actually expires.
        setstrAuthToken("");
      } else {
        setstrFilingStatus("Unfiled");
        setstrAckNo("");
      }
    } catch (e) {
      // Non-fatal -- don't block the Overview tab from showing invoice
      // data just because the status fetch failed. Status pill falls
      // back to "Unfiled" and Push/File stay gated as a safe default.
      setstrFilingStatus("Unfiled");
    }
  };

  const fnNum = (v) => {
    const n = Number(v);
    return isNaN(n) ? 0 : n;
  };

  // Uses CATEGORY_FIELD_MAP (real field names) to total taxable value + tax.
  // Most categories have direct IGST/CGST/SGST columns to sum.CDNR/CDNUR
  // don't -- tax there is derived as Note Value - Taxable Value - Cess.
  const Summarize_Rows = (key, rows) => {
    const map = CATEGORY_FIELD_MAP[key];
    if (!map || !map.taxable) {
      return { count: rows.length, taxable: null, tax: null };
    }
    let taxable = 0;
    let tax = 0;
    rows.forEach((r) => {
      const rowTaxable = fnNum(r[map.taxable]);
      taxable += rowTaxable;
      if (map.taxFields && map.taxFields.length > 0) {
        map.taxFields.forEach((f) => {
          tax += fnNum(r[f]);
        });
      } else if (map.noteValue) {
        const cess = map.cess ? fnNum(r[map.cess]) : 0;
        tax += fnNum(r[map.noteValue]) - rowTaxable - cess;
      }
    });
    return { count: rows.length, taxable, tax };
  };

  // Client-side validation -- flags rows missing HSN code before the
  // customer is allowed to push to GSTN. Real GST portal will reject
  // filing if HSN is missing on invoices above the turnover threshold.
  const Validate_GSTR1 = (rawData) => {
    const errors = [];
    // Only HSN Summary is checked here -- GSTN's B2B schema has no
    // per-invoice HSN field (confirmed against the Sandbox/WhiteBooks
    // API docs), so B2B was never a valid place to require it.
    ["HSN"].forEach((key) => {
      const map = CATEGORY_FIELD_MAP[key];
      (rawData[key] || []).forEach((r) => {
        const hsnVal = map.hsn ? (r[map.hsn] || "").toString().trim() : "";
        if (!hsnVal) {
          errors.push({
            section: key,
            invoice: map.invoiceNo ? r[map.invoiceNo] : r["ProName"],
            issue: "Missing HSN code",
          });
        }
      });
    });
    setarrValidationErrors(errors);
  };

  const fnFormatCurrency = (val) => {
    if (val === null || val === undefined) return "Confirm columns";
    return "\u20B9" + Number(val).toLocaleString("en-IN", { maximumFractionDigits: 0 });
  };

  const CARD_META = [
    { key: "B2B", label: "B2B invoices", icon: "fa-solid fa-building" },
    { key: "B2CL", label: "B2C large", icon: "fa-solid fa-user-tie" },
    { key: "B2CS", label: "B2C small", icon: "fa-solid fa-cart-shopping" },
    { key: "CDNR", label: "Credit/debit notes", icon: "fa-solid fa-file-invoice" },
    { key: "CDNUR", label: "CDN unregistered", icon: "fa-solid fa-file-circle-exclamation" },
    { key: "HSN", label: "HSN summary", icon: "fa-solid fa-list" },
  ];

  // Builds ReactTable columns dynamically from EntDesign -- same approach
  // as GeneralReports.js / ReportTable.js, so it stays correct even if
  // column order or visibility changes on the report-design side.
  const Build_Columns = (design) => {
    if (!design || design.length === 0) return [];
    return design
      .filter((d) => d.isShowInReport)
      .map((d) => ({
        Header: d.strAliasName,
        accessor: d.strRptColName,
        Datatype: d.strDatatype === "decimal" ? "Decimal" : undefined,
        minWidth: d.iRptColLen,
        style: { justifyContent: d.iFontAlign === 3 ? "right" : "left" },
      }));
  };

  // ---- Document Issued save (mandatory before filing, per GST rules) ----
  const Save_DocumentIssued = async () => {
    try {
      if (!strDocFrom || !strDocTo) {
        AlertMessage("Please Enter Document Series From and To", "info");
        return;
      }
      await dispatch(setload_Screen(true));
      const objDoc = {
        strDocFrom, strDocTo,
        iDocTotal: Number(iDocTotal),
        iDocCancelled: Number(iDocCancelled),
        iMonth, iYear,
        strCompanyDB: localStorage.db,
        iUserId: Number(localStorage.UserId),
      };
      // TODO (backend): create GSTRController.SaveDocumentIssued -> GST_GSTR1_DocSeries table
      await userApp.post(`GST/Save_DocumentIssued`, objDoc).then((Res) => {
        if (Res.data.strStatus === "Success") {
          AlertMessage("Document Issued details saved", "success");
        } else {
          AlertMessage(Res.data.strMessage, "error");
        }
      });
    } catch (e) {
      AlertMessage(e.message, "error");
    } finally {
      dispatch(setload_Screen(false));
    }
  };

  
  const Save_ApiCredential = async () => {
    if (!gstrCred.ApiUserName.trim() || !gstrCred.ApiPassword.trim()) {
      AlertMessage("Please Enter API Username and Password", "info");
      return;
    }
    try {
      setisCredSaving(true);
      const objReq = {
        ClientId: iClientId,
        strCompanyDB: localStorage.db,
        ApiUserName: gstrCred.ApiUserName.trim(),
        ApiPassword: gstrCred.ApiPassword.trim(),
      };
      const Res = await userApp.post(`GST/Save_Credential`, objReq);
      if (Res.data.strStatus === "Success") {
        AlertMessage("GSTR API credential saved", "success");
        setisCredModal(false);
        setisCredSaved(true);
        setgstrCred({ ApiUserName: "", ApiPassword: "" });
        await Request_OTP();
      } else {
        AlertMessage(Res.data.strMessage, "error");
      }
    } catch (e) {
      AlertMessage(e.message, "error");
    } finally {
      setisCredSaving(false);
    }
  };

  // ---- OTP + Push to GSTN flow (TaxPro GSP, mirrors EInvoice/EWayBill auth pattern) ----
  const Request_OTP = async () => {
    try {
      if (!iClientId || isNaN(iClientId)) {
        AlertMessage("Unable to identify the client for this company -- please contact support.", "error");
        return;
      }
      await dispatch(setload_Screen(true));
      const objReq = {
        iMonth, iYear,
        iClientId,
        strCompanyDB: localStorage.db,
        iUserId: Number(localStorage.UserId),
      };
      // TODO (backend): TaxProGSTRBAL.RequestOTP() -- sends OTP to registered mobile via GSTN
      await userApp.post(`GST/Request_OTP`, objReq).then((Res) => {
        if (Res.data.strStatus === "Success") {
          setisOTPModal(true);
          setiResendCooldown(30);
        } else if ((Res.data.strMessage || "").toLowerCase().includes("credential not set up")) {
          // First-time customer -- guide them straight to the credential
          // popup instead of leaving them stuck on a dead-end error toast.
          setisCredSaved(false);
          setisCredModal(true);
        } else {
          AlertMessage(Res.data.strMessage, "error");
        }
      });
    } catch (e) {
      AlertMessage(e.message, "error");
    } finally {
      dispatch(setload_Screen(false));
    }
  };

  const Verify_OTP_PushGSTN = async () => {
    try {
      if (!strOTP) {
        AlertMessage("Please Enter OTP", "info");
        return;
      }
      await dispatch(setload_Screen(true));
      const objVerify = {
        strOTP, iMonth, iYear,
        iClientId,
        strCompanyDB: localStorage.db,
        iUserId: Number(localStorage.UserId),
      };
      // TODO (backend): TaxProGSTRBAL.GetAuthToken(otp) then PushGSTR1(jsonPayload)
      await userApp.post(`GST/Verify_OTP_And_Push`, objVerify).then((Res) => {
        if (Res.data.strStatus === "Success") {
          console.log("==== GSTR1 DEBUG: Verify_OTP_PushGSTN success -- setting strAuthToken ====", Res.data.strAuthToken ? Res.data.strAuthToken.substring(0, 15) + "..." : "(EMPTY/UNDEFINED!)");
          setstrAuthToken(Res.data.strAuthToken);
          setstrFilingStatus("Pushed");
          setisOTPModal(false);
          setstrOTP("");
          AlertMessage("Data pushed to GSTN successfully", "success");
        } else {
          AlertMessage(Res.data.strMessage, "error");
        }
      });
    } catch (e) {
      AlertMessage(e.message, "error");
    } finally {
      dispatch(setload_Screen(false));
    }
  };

  // ---- Step 1: Proceed to File (generates GSTN summary) + Request File OTP ----
  const Start_Filing = async () => {
    
    if (!strAuthToken) {
      console.log("==== GSTR1 DEBUG: Start_Filing blocked -- strAuthToken is empty at click time ====", { strAuthToken, strFilingStatus });
      AlertMessage("Your GSTN session has expired since the last push. Please go to 'Push to GSTN' and verify OTP again before filing.", "info");
      setstrActiveTab("Push");
      return;
    }
    console.log("==== GSTR1 DEBUG: Start_Filing proceeding -- token present ====", { strAuthToken: strAuthToken.substring(0, 15) + "..." });
    try {
      await dispatch(setload_Screen(true));
      const objCommon = {
        iMonth, iYear, strAuthToken,
        iClientId,
        strCompanyDB: localStorage.db,
        iUserId: Number(localStorage.UserId),
      };

      // TODO (backend): TaxProGSTRBAL.ProceedToFile() -- marks return ready to file
      const proceedRes = await userApp.post(`GST/Proceed_To_File`, objCommon);
      if (proceedRes.data.strStatus !== "Success") {
        AlertMessage(proceedRes.data.strMessage, "error");
        return;
      }

      // TODO (backend): TaxProGSTRBAL.RequestFileOTP() -- separate EVC OTP, sent to registered mobile
      const otpRes = await userApp.post(`GST/Request_File_OTP`, objCommon);
      if (otpRes.data.strStatus === "Success") {
        setisFileOTPModal(true);
        setiFileResendCooldown(30);
      } else {
        AlertMessage(otpRes.data.strMessage, "error");
      }
    } catch (e) {
      AlertMessage(e.message, "error");
    } finally {
      dispatch(setload_Screen(false));
    }
  };

  // ---- Step 2: Final File_Return (after user enters the File OTP) ----
  const File_Return = async () => {
    try {
      if (!strFileOTP) {
        AlertMessage("Please Enter File OTP", "info");
        return;
      }
      await dispatch(setload_Screen(true));
      const objFile = {
        iMonth, iYear, strAuthToken,
        strFileOtp: strFileOTP,
        iClientId,
        strCompanyDB: localStorage.db,
        iUserId: Number(localStorage.UserId),
      };
      // TODO (backend): TaxProGSTRBAL.FileReturn() -- final submit, returns ARN
      await userApp.post(`GST/File_Return`, objFile).then((Res) => {
        if (Res.data.strStatus === "Success") {
          setstrAckNo(Res.data.strAckNo);
          setstrFilingStatus("Filed");
          setisFileOTPModal(false);
          setstrFileOTP("");
          AlertMessage("GSTR-1 filed successfully", "success");
        } else {
          AlertMessage(Res.data.strMessage, "error");
        }
      });
    } catch (e) {
      AlertMessage(e.message, "error");
    } finally {
      dispatch(setload_Screen(false));
    }
  };

  // Inline-styled (not CSS-class dependent) so it's guaranteed visible
  // regardless of whether gstr1-pill-* classes exist in the stylesheet --
  // same solid darkgreen-background/white-text pattern used everywhere
  // else in the app (Credential/OTP popup headers, etc).
  const getStatusPillStyle = () => ({
    display: "inline-flex",
    alignItems: "center",
    padding: "6px 16px",
    borderRadius: 20,
    fontSize: 13,
    fontWeight: 700,
    letterSpacing: "0.3px",
    background: "darkgreen",
    color: "#fff",
  });

  const activeColumns = Build_Columns(objDesign[strActiveCard]);
  const activeMap = CATEGORY_FIELD_MAP[strActiveCard];

  return (
    <>
      <SideMenu ScrId={111} />
      <Messagedialogbox />
      <div className="gstr1-wrap">
        <div className="gstr1-header">
          <div>
            <h2 className="gstr1-title">GSTR-1 Filing</h2>
            <p className="gstr1-subtitle">Details of outward supplies of goods and services</p>
          </div>
          <div className="gstr1-header-actions">
            <select className="form-control gstr1-period-select" value={iMonth} onChange={(e) => setiMonth(Number(e.target.value))}>
              {MONTHS.map((m, idx) => (<option key={idx} value={idx + 1}>{m}</option>))}
            </select>
            <select className="form-control gstr1-period-select" value={iYear} onChange={(e) => setiYear(Number(e.target.value))}>
              {[iYear - 1, iYear, iYear + 1].map((y) => (<option key={y} value={y}>{y}</option>))}
            </select>
            <span style={getStatusPillStyle()}>{strFilingStatus}</span>
          </div>
        </div>

        <div className="gstr1-tabs">
          <div className={`gstr1-tab ${strActiveTab === "Overview" ? "active" : ""}`} onClick={() => setstrActiveTab("Overview")}>1. Overview</div>
          <div className={`gstr1-tab ${strActiveTab === "Push" ? "active" : ""}`} onClick={() => setstrActiveTab("Push")}>2. Push to GSTN</div>
          <div className={`gstr1-tab ${strActiveTab === "File" ? "active" : ""}`} onClick={() => setstrActiveTab("File")}>3. File Return</div>
        </div>

        {strActiveTab === "Overview" && (
          <>
            <div className="gstr1-card-grid">
              {CARD_META.map((c) => (
                <div key={c.key} className={`gstr1-card ${strActiveCard === c.key ? "gstr1-card-active" : ""}`} onClick={() => setstrActiveCard(c.key)}>
                  <i className={c.icon}></i>
                  <p className="gstr1-card-label">{c.label}</p>
                  <p className="gstr1-card-count">{objSummary[c.key].count}</p>
                  <p className="gstr1-card-amount">{fnFormatCurrency(objSummary[c.key].taxable)}{objSummary[c.key].taxable !== null ? " taxable" : ""}</p>
                </div>
              ))}
            </div>

            {!activeMap.confirmed && (
              <div className="gstr1-alert-banner">
                <i className="fa-solid fa-triangle-exclamation"></i>
                Column names for "{strActiveCard}" are not confirmed yet -- share a sample API response for RptId {RPT[strActiveCard]} to complete totals.
              </div>
            )}

            {arrValidationErrors.length > 0 && (
              <div className="gstr1-alert-banner">
                <i className="fa-solid fa-triangle-exclamation"></i>
                {arrValidationErrors.length} row(s) missing HSN code -- GST portal will reject filing until these are fixed in the invoices
              </div>
            )}

            <div className="gstr1-detail-table">
              <ReactTable
                columns={activeColumns}
                data={objRaw[strActiveCard] || []}
                minRows={5}
                row_click={() => {}}
                row_doubleclick={() => {}}
                background={true}
                className="full-table"
              />
            </div>
          </>
        )}

        {strActiveTab === "Push" && (
          <div className="gstr1-panel">
            <h3 className="gstr1-panel-title">Documents issued</h3>
            <div className="row">
              <div className="col-sm-6 col-md-3">
                <label>Series from</label>
                <input type="text" className="form-control" value={strDocFrom} onChange={(e) => setstrDocFrom(e.target.value)} placeholder="INV-0001" />
              </div>
              <div className="col-sm-6 col-md-3">
                <label>Series to</label>
                <input type="text" className="form-control" value={strDocTo} onChange={(e) => setstrDocTo(e.target.value)} placeholder="INV-0042" />
              </div>
              <div className="col-sm-6 col-md-3">
                <label>Total number</label>
                <input type="number" className="form-control" value={iDocTotal} onChange={(e) => setiDocTotal(Number(e.target.value))} />
              </div>
              <div className="col-sm-6 col-md-3">
                <label>Cancelled</label>
                <input type="number" className="form-control" value={iDocCancelled} onChange={(e) => setiDocCancelled(Number(e.target.value))} />
              </div>
            </div>
            <button className="btn-fabgreen gstr1-btn-margin" onClick={Save_DocumentIssued}>Save&nbsp;<i className="fas fa-save"></i></button>

            <hr />

            <h3 className="gstr1-panel-title">Push data to GSTN</h3>
            <p className="gstr1-help-text">This will request an OTP on the registered mobile number linked to your GSTIN, then securely push the summarized invoice data to GSTN.</p>
            {isCredSaved === false && (
              <div className="gstr1-alert-banner">
                <i className="fa-solid fa-triangle-exclamation"></i>
                GSTR API credential not set up for this GSTIN yet.&nbsp;
                <button type="button" className="gstr1-link-btn" onClick={() => setisCredModal(true)}>Set it up now</button>
              </div>
            )}
            <button className="btn-fabgreen" onClick={Request_OTP} disabled={arrValidationErrors.length > 0}>Push to GSTN&nbsp;<i className="fa-solid fa-paper-plane"></i></button>
            {arrValidationErrors.length > 0 && (<p className="gstr1-error-text">{arrValidationErrors.length} row(s) missing HSN code -- fix these invoices in the Overview tab before pushing to GSTN.</p>)}
          </div>
        )}

        {strActiveTab === "File" && (
          <div className="gstr1-panel">
            <h3 className="gstr1-panel-title">File your return</h3>
            <table className="gstr1-summary-table">
              <thead>
                <tr><th>Category</th><th>Total transactions</th><th>Taxable amount</th><th>Tax amount</th></tr>
              </thead>
              <tbody>
                {CARD_META.map((c) => (
                  <tr key={c.key}>
                    <td>{c.label}</td>
                    <td>{objSummary[c.key].count}</td>
                    <td>{fnFormatCurrency(objSummary[c.key].taxable)}</td>
                    <td>{fnFormatCurrency(objSummary[c.key].tax)}</td>
                  </tr>
                ))}
              </tbody>
            </table>

            {strAckNo && (
              <div className="gstr1-ack-box">
                <i className="fa-solid fa-circle-check"></i>
                Filed successfully. Acknowledgement No: <b>{strAckNo}</b>
              </div>
            )}

            {/* ⚠ FIX -- "Filed" state was falling into the same disabled-button
                branch as "Unfiled", showing the confusing "Push data to GSTN
                first" warning right below the "Filed successfully" success
                banner. Filed is now its own terminal state: no action button,
                no warning text, just the success banner above. */}
            {strFilingStatus === "Filed" ? null : (
              <>
                <button className="btn-fabgreen gstr1-btn-margin" onClick={Start_Filing} disabled={strFilingStatus !== "Pushed"}>File Return&nbsp;<i className="fa-solid fa-check"></i></button>
                {strFilingStatus !== "Pushed" && (<p className="gstr1-error-text">Push data to GSTN first (tab 2) before filing.</p>)}
              </>
            )}
          </div>
        )}
      </div>

      {isCredModal && (
        <CredentialModal
          cred={gstrCred}
          onChange={setgstrCred}
          onSave={Save_ApiCredential}
          onClose={() => {
            setisCredModal(false);
            setgstrCred({ ApiUserName: "", ApiPassword: "" });
          }}
          saving={isCredSaving}
        />
      )}

      {isOTPModal && (
        <OTPModal
          title="Verify OTP"
          subtitle="Enter the OTP sent to your GSTN registered mobile"
          otp={strOTP}
          onChange={setstrOTP}
          onSubmit={Verify_OTP_PushGSTN}
          onClose={() => { setisOTPModal(false); setstrOTP(""); }}
          onResend={Request_OTP}
          resendCooldown={iResendCooldown}
          submitLabel="Verify & Push"
          submitting={false}
        />
      )}

      {isFileOTPModal && (
        <OTPModal
          title="Verify File OTP"
          subtitle="Enter the OTP sent to your GSTN registered mobile to file the return"
          otp={strFileOTP}
          onChange={setstrFileOTP}
          onSubmit={File_Return}
          onClose={() => { setisFileOTPModal(false); setstrFileOTP(""); }}
          onResend={Start_Filing}
          resendCooldown={iFileResendCooldown}
          submitLabel="File Return"
          submitting={false}
        />
      )}
    </>
  );
}

export default Gstr1;



// import { useEffect, useState } from "react";
// import SideMenu from "../General/SideMenu";
// import ReactTable from "../General/ReactTable";
// import { useDispatch } from "react-redux";
// import { Show_MsgBox, setload_Screen } from "../ReduxStore/Message";
// import { userApp } from "../Admin/Utility";
// import Messagedialogbox from "../General/Messagedialogbox";

// // ═══════════════════════════════════════════════════════════════
// //  OTP POPUP — same branded pattern as CredentialModal above.
// //  Reused for both the Push-OTP and File-OTP steps (title/subtitle/
// //  submitLabel differ, everything else is identical).
// // ═══════════════════════════════════════════════════════════════
// function OTPModal({ title, subtitle, otp, onChange, onSubmit, onClose, onResend, resendCooldown, submitLabel, submitting }) {
//   return (
//     <div
//       style={{
//         position: "fixed",
//         inset: 0,
//         zIndex: 10000,
//         background: "rgba(0,0,0,0.6)",
//         backdropFilter: "blur(4px)",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//       }}
//     >
//       <div
//         style={{
//           background: "#fff",
//           borderRadius: 14,
//           width: 400,
//           boxShadow: "0 24px 80px rgba(0,0,0,0.3)",
//           animation: "modalPop 0.25s cubic-bezier(0.34,1.56,0.64,1)",
//           overflow: "hidden",
//         }}
//       >
//         <div
//           style={{
//             background: "darkgreen",
//             padding: "24px 28px",
//             display: "flex",
//             alignItems: "center",
//             gap: 14,
//           }}
//         >
//           <div
//             style={{
//               width: 44,
//               height: 44,
//               borderRadius: 10,
//               background: "rgba(255,255,255,0.12)",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//               fontSize: 22,
//             }}
//           >
//             📱
//           </div>
//           <div>
//             <div style={{ fontWeight: 700, fontSize: 16, color: "#fff" }}>{title}</div>
//             <div style={{ fontSize: 12, color: "rgba(255,255,255,0.6)", marginTop: 2 }}>{subtitle}</div>
//           </div>
//           <button
//             onClick={onClose}
//             style={{
//               marginLeft: "auto",
//               width: 28,
//               height: 28,
//               borderRadius: "50%",
//               background: "rgba(255,255,255,0.15)",
//               border: "none",
//               color: "#fff",
//               fontSize: 14,
//               cursor: "pointer",
//               flexShrink: 0,
//             }}
//           >
//             ✕
//           </button>
//         </div>
//         <div style={{ padding: "24px 28px 20px" }}>
//           <div style={{ marginBottom: 8 }}>
//             <label
//               style={{
//                 fontSize: 11,
//                 fontWeight: 700,
//                 color: "#6b7280",
//                 display: "block",
//                 marginBottom: 6,
//                 letterSpacing: "0.5px",
//                 textTransform: "uppercase",
//               }}
//             >
//               6-Digit OTP
//             </label>
//             <input
//               type="text"
//               inputMode="numeric"
//               pattern="[0-9]*"
//               maxLength={6}
//               className="form-control"
//               placeholder="000000"
//               value={otp}
//               onChange={(e) => onChange(e.target.value.replace(/\D/g, ""))}
//               autoComplete="off"
//               style={{ fontSize: 20, letterSpacing: "6px", textAlign: "center", fontWeight: 700 }}
//             />
//           </div>
//           <div style={{ marginBottom: 20, textAlign: "right" }}>
//             <button
//               type="button"
//               onClick={onResend}
//               disabled={resendCooldown > 0}
//               style={{
//                 background: "none",
//                 border: "none",
//                 color: resendCooldown > 0 ? "#9ca3af" : "darkgreen",
//                 fontSize: 12,
//                 fontWeight: 600,
//                 cursor: resendCooldown > 0 ? "not-allowed" : "pointer",
//                 padding: 0,
//               }}
//             >
//               {resendCooldown > 0 ? `Resend OTP in ${resendCooldown}s` : "Resend OTP"}
//             </button>
//           </div>
//           <div style={{ display: "flex", gap: 10 }}>
//             <button
//               onClick={onClose}
//               disabled={submitting}
//               style={{
//                 flex: 1,
//                 padding: "10px",
//                 borderRadius: 8,
//                 border: "1.5px solid #e5e7eb",
//                 background: "#fff",
//                 color: "#374151",
//                 fontWeight: 600,
//                 fontSize: 13,
//                 cursor: submitting ? "not-allowed" : "pointer",
//                 opacity: submitting ? 0.5 : 1,
//               }}
//             >
//               Cancel
//             </button>
//             <button
//               onClick={onSubmit}
//               disabled={submitting || otp.length !== 6}
//               style={{
//                 flex: 1,
//                 padding: "10px",
//                 borderRadius: 8,
//                 border: "none",
//                 background: submitting || otp.length !== 6 ? "#9ca3af" : "darkgreen",
//                 color: "#fff",
//                 fontWeight: 700,
//                 fontSize: 13,
//                 cursor: submitting || otp.length !== 6 ? "not-allowed" : "pointer",
//               }}
//             >
//               {submitting ? "Verifying..." : submitLabel}
//             </button>
//           </div>
//         </div>
//       </div>
//       <style>{`@keyframes modalPop{from{opacity:0;transform:scale(0.85)}to{opacity:1;transform:scale(1)}}`}</style>
//     </div>
//   );
// }
// // ═══════════════════════════════════════════════════════════════
// //  CREDENTIAL POPUP — ported 1:1 from EInvoice.js's CredentialModal
// //  (same dark-green branded header, icon, info banner, button style)
// //  so this matches the app's actual professional modal pattern
// //  instead of the plain gstr1-modal-overlay/popup-header markup.
// // ═══════════════════════════════════════════════════════════════
// function CredentialModal({ cred, onChange, onSave, onClose, saving }) {
//   return (
//     <div
//       style={{
//         position: "fixed",
//         inset: 0,
//         zIndex: 10000,
//         background: "rgba(0,0,0,0.6)",
//         backdropFilter: "blur(4px)",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//       }}
//     >
//       <div
//         style={{
//           background: "#fff",
//           borderRadius: 14,
//           width: 420,
//           boxShadow: "0 24px 80px rgba(0,0,0,0.3)",
//           animation: "modalPop 0.25s cubic-bezier(0.34,1.56,0.64,1)",
//           overflow: "hidden",
//         }}
//       >
//         <div
//           style={{
//             background: "darkgreen",
//             padding: "24px 28px",
//             display: "flex",
//             alignItems: "center",
//             gap: 14,
//           }}
//         >
//           <div
//             style={{
//               width: 44,
//               height: 44,
//               borderRadius: 10,
//               background: "rgba(255,255,255,0.12)",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//               fontSize: 22,
//             }}
//           >
//             🔐
//           </div>
//           <div>
//             <div style={{ fontWeight: 700, fontSize: 16, color: "#fff" }}>
//               GSTR-1 API Credentials
//             </div>
//             <div
//               style={{
//                 fontSize: 12,
//                 color: "rgba(255,255,255,0.6)",
//                 marginTop: 2,
//               }}
//             >
//               GST Portal Login — required for GSTR-1 API access
//             </div>
//           </div>
//         </div>
//         <div style={{ padding: "24px 28px 20px" }}>
//           <div style={{ marginBottom: 16 }}>
//             <label
//               style={{
//                 fontSize: 11,
//                 fontWeight: 700,
//                 color: "#6b7280",
//                 display: "block",
//                 marginBottom: 6,
//                 letterSpacing: "0.5px",
//                 textTransform: "uppercase",
//               }}
//             >
//               GST Username
//             </label>
//             <input
//               type="text"
//               className="form-control"
//               placeholder="Enter GST portal username"
//               value={cred.ApiUserName}
//               onChange={(e) => onChange({ ...cred, ApiUserName: e.target.value })}
//               autoComplete="off"
//               style={{ fontSize: 13 }}
//             />
//           </div>
//           <div style={{ marginBottom: 24 }}>
//             <label
//               style={{
//                 fontSize: 11,
//                 fontWeight: 700,
//                 color: "#6b7280",
//                 display: "block",
//                 marginBottom: 6,
//                 letterSpacing: "0.5px",
//                 textTransform: "uppercase",
//               }}
//             >
//               GST Password
//             </label>
//             <input
//               type="password"
//               className="form-control"
//               placeholder="Enter GST portal password"
//               value={cred.ApiPassword}
//               onChange={(e) => onChange({ ...cred, ApiPassword: e.target.value })}
//               autoComplete="new-password"
//               style={{ fontSize: 13 }}
//             />
//           </div>
//           <div
//             style={{
//               background: "#eff6ff",
//               border: "1px solid #bfdbfe",
//               borderRadius: 8,
//               padding: "10px 12px",
//               marginBottom: 20,
//               fontSize: 11.5,
//               color: "#1e40af",
//               lineHeight: 1.5,
//             }}
//           >
//             ℹ️ These credentials are used only for GSTR-1 filing API authentication (GST portal -&gt; API Registration -&gt; Through GSP). They are stored securely and encrypted.
//           </div>
//           <div style={{ display: "flex", gap: 10 }}>
//             <button
//               onClick={onClose}
//               disabled={saving}
//               style={{
//                 flex: 1,
//                 padding: "10px",
//                 borderRadius: 8,
//                 border: "1.5px solid #e5e7eb",
//                 background: "#fff",
//                 color: "#374151",
//                 fontWeight: 600,
//                 fontSize: 13,
//                 cursor: saving ? "not-allowed" : "pointer",
//                 opacity: saving ? 0.5 : 1,
//               }}
//             >
//               Cancel
//             </button>
//             <button
//               onClick={onSave}
//               disabled={saving}
//               style={{
//                 flex: 1,
//                 padding: "10px",
//                 borderRadius: 8,
//                 border: "none",
//                 background: saving ? "#9ca3af" : "darkgreen",
//                 color: "#fff",
//                 fontWeight: 700,
//                 fontSize: 13,
//                 cursor: saving ? "not-allowed" : "pointer",
//               }}
//             >
//               {saving ? "Saving..." : "Save & Push"}
//             </button>
//           </div>
//         </div>
//       </div>
//       <style>{`@keyframes modalPop{from{opacity:0;transform:scale(0.85)}to{opacity:1;transform:scale(1)}}`}</style>
//     </div>
//   );
// }


// const RPT = {
//   B2B: 107,
//   B2CL: 108,
//   B2CS: 109,
//   CDNR: 110,
//   CDNUR: 111,
//   HSN: 113,
// };


// const CATEGORY_FIELD_MAP = {
//   B2B: {
//     confirmed: true,
//     taxable: "Taxable Value",
//     taxFields: ["Integrated Tax Paid-IGST", "Central Tax Paid-CGST", "State/UT Tax Paid-SGST"],
//     hsn: "HSNCode",
//     invoiceNo: "Invoice Number",
//   },
//   B2CL: {
//     confirmed: true,
//     taxable: "Taxable Value",
//     taxFields: ["Tax Rate"], // misleadingly named column, actually holds the tax amount
//     hsn: null, // no per-row HSN in this report, HSN is reported separately
//     invoiceNo: "Invoice Number",
//   },
//   B2CS: {
//     // Same reporting engine/structure as confirmed B2CL above.
//     confirmed: true,
//     taxable: "Taxable Value",
//     taxFields: ["Tax Rate"],
//     hsn: null,
//     invoiceNo: "Invoice Number",
//   },
//   CDNR: {
//     confirmed: true,
//     taxable: "Taxable Value",
//     noteValue: "Note Value",
//     cess: "Cess Amount",
//     taxFields: [], // no direct IGST/CGST/SGST columns -- tax is derived, see Summarize_Rows
//     hsn: null, // credit/debit notes don't carry HSN in this report
//     invoiceNo: "Note Number",
//   },
//   CDNUR: {
//     confirmed: true,
//     taxable: "Taxable Value",
//     noteValue: "Note Value",
//     cess: "Cess Amount",
//     taxFields: [],
//     hsn: null,
//     invoiceNo: "Note Number",
//   },
//   HSN: {
//     confirmed: true,
//     taxable: "TaxableAmt",
//     taxFields: ["IGSTTaxAmt", "CGSTTaxAmt", "SGSTTaxAmt"],
//     hsn: "HSN",
//     invoiceNo: null,
//   },
// };

// const MONTHS = [
//   "January", "February", "March", "April", "May", "June",
//   "July", "August", "September", "October", "November", "December",
// ];

// function Gstr1() {
//   const dispatch = useDispatch();

//   const today = new Date();
//   const [iMonth, setiMonth] = useState(today.getMonth() + 1);
//   const [iYear, setiYear] = useState(today.getFullYear());

//   const [strActiveTab, setstrActiveTab] = useState("Overview"); // Overview | Push | File
//   const [strActiveCard, setstrActiveCard] = useState("B2B");

//   const [objRaw, setobjRaw] = useState({
//     B2B: [], B2CL: [], B2CS: [], CDNR: [], CDNUR: [], HSN: [],
//   });
//   // EntDesign per category -- drives dynamic table columns, same as GeneralReports.js
//   const [objDesign, setobjDesign] = useState({
//     B2B: [], B2CL: [], B2CS: [], CDNR: [], CDNUR: [], HSN: [],
//   });

//   const [objSummary, setobjSummary] = useState({
//     B2B: { count: 0, taxable: 0, tax: 0 },
//     B2CL: { count: 0, taxable: 0, tax: 0 },
//     B2CS: { count: 0, taxable: 0, tax: 0 },
//     CDNR: { count: 0, taxable: 0, tax: 0 },
//     CDNUR: { count: 0, taxable: 0, tax: 0 },
//     HSN: { count: 0, taxable: 0, tax: 0 },
//   });

//   const [arrValidationErrors, setarrValidationErrors] = useState([]);
//   const [strFilingStatus, setstrFilingStatus] = useState("Unfiled"); // Unfiled | Pushed | Filed

//   // ---- Document Issued (mandatory manual entry, same as Zoho) ----
//   const [strDocFrom, setstrDocFrom] = useState("");
//   const [strDocTo, setstrDocTo] = useState("");
//   const [iDocTotal, setiDocTotal] = useState(0);
//   const [iDocCancelled, setiDocCancelled] = useState(0);

//   // ---- OTP / Auth flow ----
//   const [isOTPModal, setisOTPModal] = useState(false);
//   const [strOTP, setstrOTP] = useState("");
//   const [strAuthToken, setstrAuthToken] = useState("");
//   const [strAckNo, setstrAckNo] = useState("");

//   // ---- File OTP (separate EVC OTP, needed only at final File step) ----
//   const [isFileOTPModal, setisFileOTPModal] = useState(false);
//   const [strFileOTP, setstrFileOTP] = useState("");

//   // ---- GSTR API credential (GST portal -> API Registration -> Through GSP) ----
//   // Mandatory before Push_to_GSTN can work. Without this popup, a first-time
//   // customer has literally no way to set this up from this screen -- Request_OTP
//   // just fails on the backend with "credential not set up" and dead-ends here.
//   const [isCredModal, setisCredModal] = useState(false);
//   const [gstrCred, setgstrCred] = useState({ ApiUserName: "", ApiPassword: "" });
//   const [isCredSaving, setisCredSaving] = useState(false);
//   const [isCredSaved, setisCredSaved] = useState(null); // null = unknown yet, true/false once checked

//   // ---- Resend-OTP cooldowns (both OTP types) -- prevents spamming GSTN
//   // with repeat OTP requests, and gives the customer a clear "try again
//   // in Ns" signal instead of a dead modal if the first OTP never arrives ----
//   const [iResendCooldown, setiResendCooldown] = useState(0);
//   const [iFileResendCooldown, setiFileResendCooldown] = useState(0);

//   useEffect(() => {
//     if (iResendCooldown <= 0) return;
//     const t = setTimeout(() => setiResendCooldown((s) => s - 1), 1000);
//     return () => clearTimeout(t);
//   }, [iResendCooldown]);

//   useEffect(() => { 
//     if (iFileResendCooldown <= 0) return;
//     const t = setTimeout(() => setiFileResendCooldown((s) => s - 1), 1000);
//     return () => clearTimeout(t);
//   }, [iFileResendCooldown]);

//   // iClientId -- assumption: localStorage.ClientId, same pattern as localStorage.db / localStorage.UserId
//   const iClientId = Number(localStorage.ClientId);

//   useEffect(() => {
//     console.log("==== GSTR1 DEBUG: Load_GSTR1Data triggered (iMonth/iYear changed or mount) — this resets strAuthToken to empty ====", { iMonth, iYear });
//     Load_GSTR1Data();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [iMonth, iYear]);

//   const AlertMessage = (Msg, type) => {
//     dispatch(Show_MsgBox({ Message: Msg, Type: type, isMsg: true }));
//   };

//   const JsontoArray = (DataArray) => (DataArray !== null ? JSON.parse(DataArray) : []);

//   // Pulls all 6 GSTR1 section reports and builds the summary cards.
//   // Reuses the existing generic Reports/Load_GeneralReports endpoint --
//   // no new backend report logic needed for this part, views already exist.
//   const Load_GSTR1Data = async () => {
//     try {
//       await dispatch(setload_Screen(true));
//       const strFromDate = `${iYear}-${String(iMonth).padStart(2, "0")}-01`;
//       const objBase = {
//         iPartyId: 0,
//         strColName: "",
//         strPartyName: "",
//         strSearch: "",
//         strCompanyDB: localStorage.db,
//         strMasterDB: localStorage.Msdb,
//         iUserId: Number(localStorage.UserId),
//         CurrtPage: 1,
//         strFromDate: strFromDate,
//         iMonth: iMonth,
//         iYear: iYear,
//       };

//       const keys = Object.keys(RPT);
//       const calls = keys.map((key) =>
//         userApp.post(`Reports/Load_GeneralReports/`, { ...objBase, iRptId: RPT[key] })
//       );

//       const results = await Promise.all(calls);
//       const newRaw = {};
//       const newDesign = {};
//       const newSummary = {};

//       results.forEach((Res, idx) => {
//         const key = keys[idx];
//         if (Res.data.strStatus === "Success") {
//           const rows = JsontoArray(Res.data.EntReport);
//           newRaw[key] = rows;
//           newDesign[key] = (Res.data.EntDesign || []).sort((a, b) => a.inOrderTo - b.inOrderTo);
//           newSummary[key] = Summarize_Rows(key, rows);
//         } else {
//           newRaw[key] = [];
//           newDesign[key] = [];
//           newSummary[key] = { count: 0, taxable: 0, tax: 0 };
//         }
//       });

//       setobjRaw(newRaw);
//       setobjDesign(newDesign);
//       setobjSummary(newSummary);
//       Validate_GSTR1(newRaw);
//       await Load_FilingStatus();
//     } catch (e) {
//       AlertMessage(e.message, "error");
//     } finally {
//       dispatch(setload_Screen(false));
//     }
//   };

//   // Fetches the real Unfiled/Pushed/Filed status + ack number for this
//   // month/year from GST_GSTR1_FilingStatus, and Document Issued series
//   // from GST_GSTR1_DocSeries. Without this, the status pill and Push/File
//   // buttons would show stale in-memory state from whatever period the
//   // user was last looking at, instead of the truth for THIS period --
//   // and a page refresh would wrongly reset an already-Filed period back
//   // to "Unfiled" on screen (even though nothing changed in GSTN/DB).
//   // TODO (backend): needs a new GST/Get_FilingStatus endpoint wired to
//   // the existing IrbsGSTR1Filing.GetFilingStatus() + GetDocSeries() DAL
//   // methods -- these were built but never exposed via the Controller.
//   const Load_FilingStatus = async () => {
//     try {
//       const objReq = { iMonth, iYear, strCompanyDB: localStorage.db };
//       const Res = await userApp.post(`GST/Get_FilingStatus`, objReq);
//       if (Res.data.strStatus === "Success") {
//         setstrFilingStatus(Res.data.strFilingStatus || "Unfiled");
//         setstrAckNo(Res.data.strAckNo || "");
//         setstrDocFrom(Res.data.strDocFrom || "");
//         setstrDocTo(Res.data.strDocTo || "");
//         setiDocTotal(Res.data.iDocTotal || 0);
//         setiDocCancelled(Res.data.iDocCancelled || 0);
//         // Auth token is intentionally NOT restored here -- GSTN session
//         // tokens are short-lived, so resuming an in-progress Push->File
//         // after a page refresh isn't supported by design. If status is
//         // "Pushed" but the user reloaded the page, they'll need to Push
//         // again (re-verify OTP) before File Return is available -- this
//         // mirrors how GSTN's own OTP session actually expires.
//         setstrAuthToken("");
//       } else {
//         setstrFilingStatus("Unfiled");
//         setstrAckNo("");
//       }
//     } catch (e) {
//       // Non-fatal -- don't block the Overview tab from showing invoice
//       // data just because the status fetch failed. Status pill falls
//       // back to "Unfiled" and Push/File stay gated as a safe default.
//       setstrFilingStatus("Unfiled");
//     }
//   };

//   const fnNum = (v) => {
//     const n = Number(v);
//     return isNaN(n) ? 0 : n;
//   };

//   // Uses CATEGORY_FIELD_MAP (real field names) to total taxable value + tax.
//   // Most categories have direct IGST/CGST/SGST columns to sum.CDNR/CDNUR
//   // don't -- tax there is derived as Note Value - Taxable Value - Cess.
//   const Summarize_Rows = (key, rows) => {
//     const map = CATEGORY_FIELD_MAP[key];
//     if (!map || !map.taxable) {
//       return { count: rows.length, taxable: null, tax: null };
//     }
//     let taxable = 0;
//     let tax = 0;
//     rows.forEach((r) => {
//       const rowTaxable = fnNum(r[map.taxable]);
//       taxable += rowTaxable;
//       if (map.taxFields && map.taxFields.length > 0) {
//         map.taxFields.forEach((f) => {
//           tax += fnNum(r[f]);
//         });
//       } else if (map.noteValue) {
//         const cess = map.cess ? fnNum(r[map.cess]) : 0;
//         tax += fnNum(r[map.noteValue]) - rowTaxable - cess;
//       }
//     });
//     return { count: rows.length, taxable, tax };
//   };

//   // Client-side validation -- flags rows missing HSN code before the
//   // customer is allowed to push to GSTN. Real GST portal will reject
//   // filing if HSN is missing on invoices above the turnover threshold.
//   const Validate_GSTR1 = (rawData) => {
//     const errors = [];
//     // Only HSN Summary is checked here -- GSTN's B2B schema has no
//     // per-invoice HSN field (confirmed against the Sandbox/WhiteBooks
//     // API docs), so B2B was never a valid place to require it.
//     ["HSN"].forEach((key) => {
//       const map = CATEGORY_FIELD_MAP[key];
//       (rawData[key] || []).forEach((r) => {
//         const hsnVal = map.hsn ? (r[map.hsn] || "").toString().trim() : "";
//         if (!hsnVal) {
//           errors.push({
//             section: key,
//             invoice: map.invoiceNo ? r[map.invoiceNo] : r["ProName"],
//             issue: "Missing HSN code",
//           });
//         }
//       });
//     });
//     setarrValidationErrors(errors);
//   };

//   const fnFormatCurrency = (val) => {
//     if (val === null || val === undefined) return "Confirm columns";
//     return "\u20B9" + Number(val).toLocaleString("en-IN", { maximumFractionDigits: 0 });
//   };

//   const CARD_META = [
//     { key: "B2B", label: "B2B invoices", icon: "fa-solid fa-building" },
//     { key: "B2CL", label: "B2C large", icon: "fa-solid fa-user-tie" },
//     { key: "B2CS", label: "B2C small", icon: "fa-solid fa-cart-shopping" },
//     { key: "CDNR", label: "Credit/debit notes", icon: "fa-solid fa-file-invoice" },
//     { key: "CDNUR", label: "CDN unregistered", icon: "fa-solid fa-file-circle-exclamation" },
//     { key: "HSN", label: "HSN summary", icon: "fa-solid fa-list" },
//   ];

//   // Builds ReactTable columns dynamically from EntDesign -- same approach
//   // as GeneralReports.js / ReportTable.js, so it stays correct even if
//   // column order or visibility changes on the report-design side.
//   const Build_Columns = (design) => {
//     if (!design || design.length === 0) return [];
//     return design
//       .filter((d) => d.isShowInReport)
//       .map((d) => ({
//         Header: d.strAliasName,
//         accessor: d.strRptColName,
//         Datatype: d.strDatatype === "decimal" ? "Decimal" : undefined,
//         minWidth: d.iRptColLen,
//         style: { justifyContent: d.iFontAlign === 3 ? "right" : "left" },
//       }));
//   };

//   // ---- Document Issued save (mandatory before filing, per GST rules) ----
//   const Save_DocumentIssued = async () => {
//     try {
//       if (!strDocFrom || !strDocTo) {
//         AlertMessage("Please Enter Document Series From and To", "info");
//         return;
//       }
//       await dispatch(setload_Screen(true));
//       const objDoc = {
//         strDocFrom, strDocTo,
//         iDocTotal: Number(iDocTotal),
//         iDocCancelled: Number(iDocCancelled),
//         iMonth, iYear,
//         strCompanyDB: localStorage.db,
//         iUserId: Number(localStorage.UserId),
//       };
//       // TODO (backend): create GSTRController.SaveDocumentIssued -> GST_GSTR1_DocSeries table
//       await userApp.post(`GST/Save_DocumentIssued`, objDoc).then((Res) => {
//         if (Res.data.strStatus === "Success") {
//           AlertMessage("Document Issued details saved", "success");
//         } else {
//           AlertMessage(Res.data.strMessage, "error");
//         }
//       });
//     } catch (e) {
//       AlertMessage(e.message, "error");
//     } finally {
//       dispatch(setload_Screen(false));
//     }
//   };

  
//   const Save_ApiCredential = async () => {
//     if (!gstrCred.ApiUserName.trim() || !gstrCred.ApiPassword.trim()) {
//       AlertMessage("Please Enter API Username and Password", "info");
//       return;
//     }
//     try {
//       setisCredSaving(true);
//       const objReq = {
//         ClientId: iClientId,
//         strCompanyDB: localStorage.db,
//         ApiUserName: gstrCred.ApiUserName.trim(),
//         ApiPassword: gstrCred.ApiPassword.trim(),
//       };
//       const Res = await userApp.post(`GST/Save_Credential`, objReq);
//       if (Res.data.strStatus === "Success") {
//         AlertMessage("GSTR API credential saved", "success");
//         setisCredModal(false);
//         setisCredSaved(true);
//         setgstrCred({ ApiUserName: "", ApiPassword: "" });
//         await Request_OTP();
//       } else {
//         AlertMessage(Res.data.strMessage, "error");
//       }
//     } catch (e) {
//       AlertMessage(e.message, "error");
//     } finally {
//       setisCredSaving(false);
//     }
//   };

//   // ---- OTP + Push to GSTN flow (TaxPro GSP, mirrors EInvoice/EWayBill auth pattern) ----
//   const Request_OTP = async () => {
//     try {
//       if (!iClientId || isNaN(iClientId)) {
//         AlertMessage("Unable to identify the client for this company -- please contact support.", "error");
//         return;
//       }
//       await dispatch(setload_Screen(true));
//       const objReq = {
//         iMonth, iYear,
//         iClientId,
//         strCompanyDB: localStorage.db,
//         iUserId: Number(localStorage.UserId),
//       };
//       // TODO (backend): TaxProGSTRBAL.RequestOTP() -- sends OTP to registered mobile via GSTN
//       await userApp.post(`GST/Request_OTP`, objReq).then((Res) => {
//         if (Res.data.strStatus === "Success") {
//           setisOTPModal(true);
//           setiResendCooldown(30);
//         } else if ((Res.data.strMessage || "").toLowerCase().includes("credential not set up")) {
//           // First-time customer -- guide them straight to the credential
//           // popup instead of leaving them stuck on a dead-end error toast.
//           setisCredSaved(false);
//           setisCredModal(true);
//         } else {
//           AlertMessage(Res.data.strMessage, "error");
//         }
//       });
//     } catch (e) {
//       AlertMessage(e.message, "error");
//     } finally {
//       dispatch(setload_Screen(false));
//     }
//   };

//   const Verify_OTP_PushGSTN = async () => {
//     try {
//       if (!strOTP) {
//         AlertMessage("Please Enter OTP", "info");
//         return;
//       }
//       await dispatch(setload_Screen(true));
//       const objVerify = {
//         strOTP, iMonth, iYear,
//         iClientId,
//         strCompanyDB: localStorage.db,
//         iUserId: Number(localStorage.UserId),
//       };
//       // TODO (backend): TaxProGSTRBAL.GetAuthToken(otp) then PushGSTR1(jsonPayload)
//       await userApp.post(`GST/Verify_OTP_And_Push`, objVerify).then((Res) => {
//         if (Res.data.strStatus === "Success") {
//           console.log("==== GSTR1 DEBUG: Verify_OTP_PushGSTN success -- setting strAuthToken ====", Res.data.strAuthToken ? Res.data.strAuthToken.substring(0, 15) + "..." : "(EMPTY/UNDEFINED!)");
//           setstrAuthToken(Res.data.strAuthToken);
//           setstrFilingStatus("Pushed");
//           setisOTPModal(false);
//           setstrOTP("");
//           AlertMessage("Data pushed to GSTN successfully", "success");
//         } else {
//           AlertMessage(Res.data.strMessage, "error");
//         }
//       });
//     } catch (e) {
//       AlertMessage(e.message, "error");
//     } finally {
//       dispatch(setload_Screen(false));
//     }
//   };

//   // ---- Step 1: Proceed to File (generates GSTN summary) + Request File OTP ----
//   const Start_Filing = async () => {
    
//     if (!strAuthToken) {
//       console.log("==== GSTR1 DEBUG: Start_Filing blocked -- strAuthToken is empty at click time ====", { strAuthToken, strFilingStatus });
//       AlertMessage("Your GSTN session has expired since the last push. Please go to 'Push to GSTN' and verify OTP again before filing.", "info");
//       setstrActiveTab("Push");
//       return;
//     }
//     console.log("==== GSTR1 DEBUG: Start_Filing proceeding -- token present ====", { strAuthToken: strAuthToken.substring(0, 15) + "..." });
//     try {
//       await dispatch(setload_Screen(true));
//       const objCommon = {
//         iMonth, iYear, strAuthToken,
//         iClientId,
//         strCompanyDB: localStorage.db,
//         iUserId: Number(localStorage.UserId),
//       };

//       // TODO (backend): TaxProGSTRBAL.ProceedToFile() -- marks return ready to file
//       const proceedRes = await userApp.post(`GST/Proceed_To_File`, objCommon);
//       if (proceedRes.data.strStatus !== "Success") {
//         AlertMessage(proceedRes.data.strMessage, "error");
//         return;
//       }

//       // TODO (backend): TaxProGSTRBAL.RequestFileOTP() -- separate EVC OTP, sent to registered mobile
//       const otpRes = await userApp.post(`GST/Request_File_OTP`, objCommon);
//       if (otpRes.data.strStatus === "Success") {
//         setisFileOTPModal(true);
//         setiFileResendCooldown(30);
//       } else {
//         AlertMessage(otpRes.data.strMessage, "error");
//       }
//     } catch (e) {
//       AlertMessage(e.message, "error");
//     } finally {
//       dispatch(setload_Screen(false));
//     }
//   };

//   // ---- Step 2: Final File_Return (after user enters the File OTP) ----
//   const File_Return = async () => {
//     try {
//       if (!strFileOTP) {
//         AlertMessage("Please Enter File OTP", "info");
//         return;
//       }
//       await dispatch(setload_Screen(true));
//       const objFile = {
//         iMonth, iYear, strAuthToken,
//         strFileOtp: strFileOTP,
//         iClientId,
//         strCompanyDB: localStorage.db,
//         iUserId: Number(localStorage.UserId),
//       };
//       // TODO (backend): TaxProGSTRBAL.FileReturn() -- final submit, returns ARN
//       await userApp.post(`GST/File_Return`, objFile).then((Res) => {
//         if (Res.data.strStatus === "Success") {
//           setstrAckNo(Res.data.strAckNo);
//           setstrFilingStatus("Filed");
//           setisFileOTPModal(false);
//           setstrFileOTP("");
//           AlertMessage("GSTR-1 filed successfully", "success");
//         } else {
//           AlertMessage(Res.data.strMessage, "error");
//         }
//       });
//     } catch (e) {
//       AlertMessage(e.message, "error");
//     } finally {
//       dispatch(setload_Screen(false));
//     }
//   };

//   const getStatusPillClass = () => {
//     if (strFilingStatus === "Filed") return "gstr1-pill gstr1-pill-success";
//     if (strFilingStatus === "Pushed") return "gstr1-pill gstr1-pill-info";
//     return "gstr1-pill gstr1-pill-warning";
//   };

//   const activeColumns = Build_Columns(objDesign[strActiveCard]);
//   const activeMap = CATEGORY_FIELD_MAP[strActiveCard];

//   return (
//     <>
//       <SideMenu ScrId={111} />
//       <Messagedialogbox />
//       <div className="gstr1-wrap">
//         <div className="gstr1-header">
//           <div>
//             <h2 className="gstr1-title">GSTR-1 Filing</h2>
//             <p className="gstr1-subtitle">Details of outward supplies of goods and services</p>
//           </div>
//           <div className="gstr1-header-actions">
//             <select className="form-control gstr1-period-select" value={iMonth} onChange={(e) => setiMonth(Number(e.target.value))}>
//               {MONTHS.map((m, idx) => (<option key={idx} value={idx + 1}>{m}</option>))}
//             </select>
//             <select className="form-control gstr1-period-select" value={iYear} onChange={(e) => setiYear(Number(e.target.value))}>
//               {[iYear - 1, iYear, iYear + 1].map((y) => (<option key={y} value={y}>{y}</option>))}
//             </select>
//             <span className={getStatusPillClass()}>{strFilingStatus}</span>
//           </div>
//         </div>

//         <div className="gstr1-tabs">
//           <div className={`gstr1-tab ${strActiveTab === "Overview" ? "active" : ""}`} onClick={() => setstrActiveTab("Overview")}>1. Overview</div>
//           <div className={`gstr1-tab ${strActiveTab === "Push" ? "active" : ""}`} onClick={() => setstrActiveTab("Push")}>2. Push to GSTN</div>
//           <div className={`gstr1-tab ${strActiveTab === "File" ? "active" : ""}`} onClick={() => setstrActiveTab("File")}>3. File Return</div>
//         </div>

//         {strActiveTab === "Overview" && (
//           <>
//             <div className="gstr1-card-grid">
//               {CARD_META.map((c) => (
//                 <div key={c.key} className={`gstr1-card ${strActiveCard === c.key ? "gstr1-card-active" : ""}`} onClick={() => setstrActiveCard(c.key)}>
//                   <i className={c.icon}></i>
//                   <p className="gstr1-card-label">{c.label}</p>
//                   <p className="gstr1-card-count">{objSummary[c.key].count}</p>
//                   <p className="gstr1-card-amount">{fnFormatCurrency(objSummary[c.key].taxable)}{objSummary[c.key].taxable !== null ? " taxable" : ""}</p>
//                 </div>
//               ))}
//             </div>

//             {!activeMap.confirmed && (
//               <div className="gstr1-alert-banner">
//                 <i className="fa-solid fa-triangle-exclamation"></i>
//                 Column names for "{strActiveCard}" are not confirmed yet -- share a sample API response for RptId {RPT[strActiveCard]} to complete totals.
//               </div>
//             )}

//             {arrValidationErrors.length > 0 && (
//               <div className="gstr1-alert-banner">
//                 <i className="fa-solid fa-triangle-exclamation"></i>
//                 {arrValidationErrors.length} row(s) missing HSN code -- GST portal will reject filing until these are fixed in the invoices
//               </div>
//             )}

//             <div className="gstr1-detail-table">
//               <ReactTable
//                 columns={activeColumns}
//                 data={objRaw[strActiveCard] || []}
//                 minRows={5}
//                 row_click={() => {}}
//                 row_doubleclick={() => {}}
//                 background={true}
//                 className="full-table"
//               />
//             </div>
//           </>
//         )}

//         {strActiveTab === "Push" && (
//           <div className="gstr1-panel">
//             <h3 className="gstr1-panel-title">Documents issued</h3>
//             <div className="row">
//               <div className="col-sm-6 col-md-3">
//                 <label>Series from</label>
//                 <input type="text" className="form-control" value={strDocFrom} onChange={(e) => setstrDocFrom(e.target.value)} placeholder="INV-0001" />
//               </div>
//               <div className="col-sm-6 col-md-3">
//                 <label>Series to</label>
//                 <input type="text" className="form-control" value={strDocTo} onChange={(e) => setstrDocTo(e.target.value)} placeholder="INV-0042" />
//               </div>
//               <div className="col-sm-6 col-md-3">
//                 <label>Total number</label>
//                 <input type="number" className="form-control" value={iDocTotal} onChange={(e) => setiDocTotal(Number(e.target.value))} />
//               </div>
//               <div className="col-sm-6 col-md-3">
//                 <label>Cancelled</label>
//                 <input type="number" className="form-control" value={iDocCancelled} onChange={(e) => setiDocCancelled(Number(e.target.value))} />
//               </div>
//             </div>
//             <button className="btn-fabgreen gstr1-btn-margin" onClick={Save_DocumentIssued}>Save&nbsp;<i className="fas fa-save"></i></button>

//             <hr />

//             <h3 className="gstr1-panel-title">Push data to GSTN</h3>
//             <p className="gstr1-help-text">This will request an OTP on the registered mobile number linked to your GSTIN, then securely push the summarized invoice data to GSTN.</p>
//             {isCredSaved === false && (
//               <div className="gstr1-alert-banner">
//                 <i className="fa-solid fa-triangle-exclamation"></i>
//                 GSTR API credential not set up for this GSTIN yet.&nbsp;
//                 <button type="button" className="gstr1-link-btn" onClick={() => setisCredModal(true)}>Set it up now</button>
//               </div>
//             )}
//             <button className="btn-fabgreen" onClick={Request_OTP} disabled={arrValidationErrors.length > 0}>Push to GSTN&nbsp;<i className="fa-solid fa-paper-plane"></i></button>
//             {arrValidationErrors.length > 0 && (<p className="gstr1-error-text">{arrValidationErrors.length} row(s) missing HSN code -- fix these invoices in the Overview tab before pushing to GSTN.</p>)}
//           </div>
//         )}

//         {strActiveTab === "File" && (
//           <div className="gstr1-panel">
//             <h3 className="gstr1-panel-title">File your return</h3>
//             <table className="gstr1-summary-table">
//               <thead>
//                 <tr><th>Category</th><th>Total transactions</th><th>Taxable amount</th><th>Tax amount</th></tr>
//               </thead>
//               <tbody>
//                 {CARD_META.map((c) => (
//                   <tr key={c.key}>
//                     <td>{c.label}</td>
//                     <td>{objSummary[c.key].count}</td>
//                     <td>{fnFormatCurrency(objSummary[c.key].taxable)}</td>
//                     <td>{fnFormatCurrency(objSummary[c.key].tax)}</td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>

//             {strAckNo && (
//               <div className="gstr1-ack-box">
//                 <i className="fa-solid fa-circle-check"></i>
//                 Filed successfully. Acknowledgement No: <b>{strAckNo}</b>
//               </div>
//             )}

//             {/* ⚠ FIX -- "Filed" state was falling into the same disabled-button
//                 branch as "Unfiled", showing the confusing "Push data to GSTN
//                 first" warning right below the "Filed successfully" success
//                 banner. Filed is now its own terminal state: no action button,
//                 no warning text, just the success banner above. */}
//             {strFilingStatus === "Filed" ? null : (
//               <>
//                 <button className="btn-fabgreen gstr1-btn-margin" onClick={Start_Filing} disabled={strFilingStatus !== "Pushed"}>File Return&nbsp;<i className="fa-solid fa-check"></i></button>
//                 {strFilingStatus !== "Pushed" && (<p className="gstr1-error-text">Push data to GSTN first (tab 2) before filing.</p>)}
//               </>
//             )}
//           </div>
//         )}
//       </div>

//       {isCredModal && (
//         <CredentialModal
//           cred={gstrCred}
//           onChange={setgstrCred}
//           onSave={Save_ApiCredential}
//           onClose={() => {
//             setisCredModal(false);
//             setgstrCred({ ApiUserName: "", ApiPassword: "" });
//           }}
//           saving={isCredSaving}
//         />
//       )}

//       {isOTPModal && (
//         <OTPModal
//           title="Verify OTP"
//           subtitle="Enter the OTP sent to your GSTN registered mobile"
//           otp={strOTP}
//           onChange={setstrOTP}
//           onSubmit={Verify_OTP_PushGSTN}
//           onClose={() => { setisOTPModal(false); setstrOTP(""); }}
//           onResend={Request_OTP}
//           resendCooldown={iResendCooldown}
//           submitLabel="Verify & Push"
//           submitting={false}
//         />
//       )}

//       {isFileOTPModal && (
//         <OTPModal
//           title="Verify File OTP"
//           subtitle="Enter the OTP sent to your GSTN registered mobile to file the return"
//           otp={strFileOTP}
//           onChange={setstrFileOTP}
//           onSubmit={File_Return}
//           onClose={() => { setisFileOTPModal(false); setstrFileOTP(""); }}
//           onResend={Start_Filing}
//           resendCooldown={iFileResendCooldown}
//           submitLabel="File Return"
//           submitting={false}
//         />
//       )}
//     </>
//   );
// }

// export default Gstr1;




